<script lang="ts" setup>
import { ref, computed, nextTick, inject } from "vue"; 
import { useForm, } from "@/helpers/composables/useForm";
import { route } from "ziggy-js";
import { object, string } from "yup";
import RothcoCta from "@/components/RothcoCta.vue";
import { usePage } from "@inertiajs/vue3";
import EmailInput from "@/components/EmailInput.vue";
let route = inject('route');
let props = defineProps({
    errors: {
        type: Object,
        default: () => {
            return {};
        }
    }
})
let resetPasswordForm = useForm({
    useInertia: true,
    inertiaAlias: 'ResetPassword',
    schema: object({
        email: string().email("Invalid Email").required().default('')
    }),
});

let message = computed(() => {
    return usePage()?.props?.flash?.message ?? {
        type: null
    };
})

let computedErrors = computed(() => {
    let errors = {};
    if(props.errors.error) {
        errors.error = props.errors.error;
    }
    for(let key in resetPasswordForm.errors) {
        if(Array.isArray(resetPasswordForm.errors[key])) {
            errors[key] = resetPasswordForm.errors[key][0];
        }
        else if(typeof resetPasswordForm.errors[key] == 'string') {
            errors[key] = resetPasswordForm.errors[key];
        }
    }
    return errors
})
let hideForm = computed(() => {
    return message.value.type == 'success';
})
const resetPassword = async ()=>{
    if(resetPasswordForm.processing) return;
    
    await resetPasswordForm.validate();
    
    if(!resetPasswordForm.hasErrors){
        resetPasswordForm.post(route('web.send-password'))
    }
}
</script>
<template>
    <div class="authorization">
    <form @submit.prevent="resetPassword()" class="authorization-form forgot-password-form">
        <div class="authorization_popup-title headline-m" >Reset Password</div>
        <div class="paragraph-default">
            Enter your email address and we will send you a link to reset your password.
        </div>
        <div v-if="computedErrors.error" class="notification notification-error">
            <p class="paragraph-details"><strong>Error Notification</strong> {{ computedErrors.error }}</p>
        </div>
        <div v-if="message.type" :class="
        {
            'notification': true,
            'notification-success': message.type == 'success',
        }">
            <p class="paragraph-details">{{ message.message }}</p>
        </div>
        <EmailInput 
            v-if="!hideForm"
            v-model="resetPasswordForm.email" 
            :errors="resetPasswordForm.errors.email" 
            id="email"
        />
        <RothcoCta :disabled="resetPasswordForm.processing" type="submit" v-if="!hideForm" id="resetPasswordBtn" ctaType="button" class="primary">
            Reset Password
        </RothcoCta>
    </form>
</div>
</template>